// ES wrapper so import() exposes only `default`: webpack's namespace for the CommonJS build would copy
// the module's own `then` (kept after init), and the import promise would re-adopt it forever
import cv from '@techstark/opencv-js'

export default cv
